import { render, staticRenderFns } from "./PreviewDocument.vue?vue&type=template&id=263fc2b4&scoped=true&"
import script from "./PreviewDocument.vue?vue&type=script&lang=js&"
export * from "./PreviewDocument.vue?vue&type=script&lang=js&"
import style0 from "./PreviewDocument.vue?vue&type=style&index=0&id=263fc2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263fc2b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
